import axios from 'axios';

import requestHeaders from 'src/utils/api/headers';

export const axiosRequest = (query, variables) => axios.post(`${process.env.API_URL}?deduplicate=1`, {
    query,
    variables: {
      ...variables
    },
  },
  {
    headers: {
      'Content-Type': 'application/json',
      ...requestHeaders(),
    },
  }
)
